import { doc, FirestoreError } from 'firebase/firestore';

import {
  CollectionOptions,
  getCollection,
  updateDocWithTimestamp,
} from './helpers';

export const updatePushTokenTimezone = async (
  token: string,
  timezone: string,
): Promise<void> => {
  if (!token?.trim()) {
    throw new Error('updatePushTokenTimezone: token must not be empty');
  }

  if (!timezone?.trim()) {
    throw new Error('updatePushTokenTimezone: timezone must not be empty');
  }

  // Validate IANA timezone string — throws RangeError on invalid timezone
  new Intl.DateTimeFormat('en', { timeZone: timezone });

  const tokenCollection = getCollection(CollectionOptions.FcmTokens);
  const docRef = doc(tokenCollection, token);

  try {
    updateDocWithTimestamp(docRef, { timezone });
  } catch (error) {
    if ((error as FirestoreError).code === 'not-found') {
      // Stale/deleted token — resolve silently
      return;
    }
    throw error;
  }
};
